import { logger } from "../../../shared/utils/logger";

export const storeSessionParams = () => {
  const params = new URLSearchParams(window.location.search);
  const sessionID = params.get("session");
  const returnUrl = params.get("returnurl");
  const returnMethod = params.get("returnmethod") || "GET";

  if (sessionID) sessionStorage.setItem("session", sessionID);
  if (returnUrl) sessionStorage.setItem("returnurl", returnUrl);
  if (returnMethod) sessionStorage.setItem("returnmethod", returnMethod.toUpperCase());

  logger.debug("Stored session params:", { sessionId: sessionID, returnUrl, returnMethod });
};

export const getSessionParams = () => {
  const sessionId = sessionStorage.getItem("session");
  const returnUrl = sessionStorage.getItem("returnurl");
  const returnMethod = sessionStorage.getItem("returnmethod") || "GET";

  logger.debug("Stored session params:", { sessionId, returnUrl, returnMethod });

  return { sessionId, returnUrl, returnMethod };
};

export const clearSessionParams = () => {
  sessionStorage.removeItem("session");
  sessionStorage.removeItem("returnurl");
  sessionStorage.removeItem("returnmethod");

  logger.debug("Cleared session storage");
};
